import React, { useState, useEffect } from 'react'
import { Card, Checkbox, Row, Col, Typography, Space, Button, Dropdown, Menu, Spin } from 'antd'
import { DownOutlined, SortAscendingOutlined, SortDescendingOutlined } from '@ant-design/icons'
import CandidateCard from './CandidateCard'
import { useCallAPI } from '../../../hooks/useCallAPI'
import { PENDING_CANDIDATE_NOTES } from '../../../ApiUrl'

const { Text } = Typography

export default function CandidatesList({ results = [], loading, sortOption, onSortChange }) {
  const [selectedCandidates, setSelectedCandidates] = useState([])
  
  const onChange = (list) => {
    setSelectedCandidates(list);
  };

  const onCheckAllChange = (e) => {
    if (e.target.checked) {
      const allResumeIds = results.map(candidate => candidate.ResumeID[0]);
      setSelectedCandidates(allResumeIds);
    } else {
      setSelectedCandidates([]);
    }
  };

  const onCandidateChange = (resumeId, checked) => {
    const newSelectedCandidates = checked
      ? [...selectedCandidates, resumeId]
      : selectedCandidates.filter(id => id !== resumeId);
    
    setSelectedCandidates(newSelectedCandidates);
  };

  const sortMenu = (
    <Menu
      onClick={({ key }) => onSortChange(key)}
      selectedKeys={[sortOption]}
      items={[
        { key: 'relevance', label: 'Relevance' },
        { key: 'date', label: 'Date (Newest First)' },
        { key: 'date_asc', label: 'Date (Oldest First)' },
        { key: 'experience', label: 'Experience (Most First)' },
        { key: 'experience_asc', label: 'Experience (Least First)' },
      ]}
    />
  );

  return (
    <Card className="candidate-list-card" bodyStyle={{ padding: '16px' }}>
      {selectedCandidates.length > 0 && (
        <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between' }}>
          <Text strong>{selectedCandidates.length} candidates selected</Text>
        </div>
      )}
      <div style={{ overflowY: 'auto', flex: 1 }}>
        {
          !loading && results.map((candidate, index) => (
            <Row key={candidate?.ResumeID?.[0] || index}>
              <CandidateCard
                candidate={candidate}
                checked={selectedCandidates.includes(candidate.ResumeID?.[0])}
                onChange={checked => onCandidateChange(candidate.ResumeID?.[0], checked)}
              />
            </Row>
          ))
        }
      </div>
    </Card>
  )
}
